import CustomerExist from "../scenes/Wizard/parts/customer-exist";
import ConfirmationModal from "./confirmation-modal";
import DataHandler from "../utils/DataHandler";
import { Translate } from "react-translated";
import React, { Component } from "react";
import reqwest from "reqwest";
import F from "../Functions";
import axios from "axios";
import {
  TYPE_OF_CALL,
  SUB_TYPE_OF_CALL,
  CSV_FORM_FIELDS,
  TEMPLATE,
  CSV_COLUMNS
} from "../utils/Constants";
import {
  Icon,
  Row,
  Col,
  Modal,
  Select,
  Button,
  Spin,
  DatePicker,
  Input,
  message,
  Upload,
  AutoComplete,
  Checkbox,
  Radio
} from "antd";

const { TextArea } = Input;
const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  state = {
    loading: false,
    fileList: [],
    agent: "",
    agency_id: null,
    users: [],
    user_id: null,
    sub_type_of_call: "Thank You / Referrals",
    // agencies: [],
    selected: null,
    type_of_call: "FollowUp",
    notes: "",
    action: "upload_file",
    cols: [],
    form: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      phone2: "",
      address: "",
      address_cont: "",
      city: "",
      state: "",
      zipcode: "",
      expiration_date: null,
      rs_policy_type: "",
      rs_effective_date: null,
      notes: "",
      p_n_c_item_to_quote: null,
      parent_id: null,
      farm_bureau_number: "",
      salesforce_business_name: ""
    },
    form_error: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      phone2: "",
      expiration_date: "",
      rs_effective_date: "",
      p_n_c_item_to_quote: null,
      farm_bureau_number: "",
      salesforce_business_name: ""
    },
    ordered_cols: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      phone2: "",
      expiration_date: "",
      address: "",
      address_cont: "",
      city: "",
      state: "",
      zipcode: "",
      rs_policy_type: "",
      rs_effective_date: "",
      p_n_c_item_to_quote: "",
      notes: "",
      farm_bureau_number: "",
      salesforce_business_name: ""
    },
    showCustomerExistsModal: false,
    showDuplicateBFileConfirmationModal: false,
    showUploadListConfirmationModal: false
  };

  componentDidMount() {
    this.setState({ fileList: [] });
  }

  reloadData = () => {
    setTimeout(() => window.location.reload(), 100);
  };

  loadUsers = () => {
    this.setState({
      loading: true,
      users: []
    });
    axios
      .get("/api/agency_associations/" + this.state.agency_id)
      .then((res) => {
        let users = [];

        for (var i = 0; i < res.data.length; i++) {
          let u = res.data[i];
          users.push({
            name: u.first_name + " " + u.last_name,
            id: u.id,
            user_type: u.user_type,
            hidden: u.hidden
          });
        }

        this.setState({
          loading: false,
          users
        });
      });
  };

  updateField = (name, value) => {
    const { form } = this.state;
    form[name] = value;
    this.setState({ form });
  };

  uploadCustomer = () => {
    const data = this.state.form;
    data.agency_id = this.state.agency_id;
    data.user_id = this.state.user_id;
    data.type_of_call = this.state.type_of_call;

    // new add
    data.phone = F.removeFormatterFromPhoneNumber(data.phone);

    this.setState({
      loading: true
    });

    axios
      .post("/api/vob_add_customer", data)
      .then((res) => {
        const form = this.state.form;
        form.first_name = "";
        form.last_name = "";
        form.email = "";
        form.phone = "";
        form.address = "";
        form.address_cont = "";
        form.city = "";
        form.state = "";
        form.zipcode = "";
        form.expiration_date = null;
        form.rs_policy_type = "";
        form.rs_effective_date = null;
        form.notes = "";
        form.parent_id = null;

        this.setState((prevState) => {
          return {
            ...prevState,
            form: form,
            fileList: [],
            loading: false,
          }
        })

        message.success(F.translate(`Customers has been added successfully.`));

        this.props.hideModal();

        this.reloadData();
      })
      .catch((error) => {
        F.log(error);
        this.setState({
          loading: false
        });
      });
  };

  checkDuplicateCustomer = (phone) => {
    // new add
    const phoneNumberFormatterRemoved = F.removeFormatterFromPhoneNumber(phone);
    this.setState({
      loading: true
    });
    axios
      .post("/api/check_customer_exist", {
        // phone_number: phone,
        phone: phoneNumberFormatterRemoved,
        skip_child: false, // child will also consider
        agency_id: this.state.agency_id
      })
      .then((res) => {
        this.setState({
          loading: false
        });

        // new add
        if (res.data.exist) {
          // found duplicate
          // updateField("show_modal_customer_exist", true);
          // updateField("modal_customer_bfile_id", res.data.bfile_id);

          // update parent id
          this.updateField("parent_id", res.data.bfile_id);

          // show duplicate add customer modal
          this.setState({
            showCustomerExistsModal: true
          });
        } else {
          // update parent id
          this.updateField("parent_id", null);

          // unique customer
          this.uploadCustomer();
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        });
        F.showAndHandleServerError(error);
      });
  };

  validateFieldsSuccess = () => {
    const { agency_id, user_id, type_of_call, sub_type_of_call } = this.state;

    // reset notification
    message.destroy();

    if (agency_id === null) {
      message.error(F.translate(`Please select an Agency.`));
      return false;
    } else if (user_id === null) {
      message.error(F.translate(`Please select an Agency Staff.`));
      return false;
    } else if (type_of_call === "") {
      message.error(F.translate(`Please select Call Type.`));
      return false;
    } else if (sub_type_of_call === "") {
      message.error(F.translate(`Please select Sub Type Of Call.`));
      return false;
    }
    return true;
  };

  uploadFile = () => {
    const { fileList, type_of_call, sub_type_of_call } = this.state;

    // reset notification
    message.destroy();

    if (this.state.action === "upload_file") {
      // handle error
      // if (fileList.length === 0) {
      //   message.error(F.translate(`Please upload csv file.`));
      //   return;
      // }

      // check All Columns Correctly Selected
      // const allFieldsColumnsCorrectlySelected = F.checkAllColumnsCorrectlySelected(
      //   this.state.ordered_cols
      // );

      /** Commit the following code */
      // get Csv Ordered Columns
      // const csvOrderedColumns = F.getCsvOrderedColumns(
      //   type_of_call,
      //   sub_type_of_call,
      //   this.state.ordered_cols
      // );

      // if (csvOrderedColumns) {
      //   const formData = new FormData();
      //   fileList.forEach((file) => {
      //     formData.append("file", file);
      //   });
      //   formData.append("agency_id", this.state.agency_id);
      //   formData.append("user_id", this.state.user_id);
      //   formData.append("type_of_call", this.state.type_of_call);
      //   formData.append("sub_type_of_call", this.state.sub_type_of_call);
      //   formData.append("ordered_cols", JSON.stringify(this.state.ordered_cols));
      //   // formData.append("ordered_cols", csvOrderedColumns);
      //   formData.append("notes", this.state.notes);
      //   this.setState({
      //     loading: true,
      //   });

      //   reqwest({
      //     url: "/api/admin_upload_bfile",
      //     method: "post",
      //     processData: false,
      //     data: formData,
      //     success: (resp) => {
      //       resp = JSON.parse(resp);

      //       // reset state
      //       this.setState({
      //         fileList: [],
      //         loading: false,
      //       });

      //       // hide modal
      //       // this.props.hideModal();

      //       /**
      //        * Response: {"total_created": 0, "total_duplicate": 0, "duplicate_data": []}
      //        */

      //       const {
      //         success,
      //         total_created,
      //         total_duplicate,
      //         duplicate_data,
      //       } = resp;

      //       // const a = Object.keys(duplicate_data).length > 0;

      //       /** Handle Server Message */

      //       if (success) {
      //         // show error if none of customer uploaded
      //         if (total_created === 0 && total_duplicate === 0) {
      //           message.error("Customers not uploaded");
      //           this.props.hideModal();
      //         } else if (duplicate_data.data.length > 0) {
      //           // set response `Duplicate data` in DataHandler class for using on next screen
      //           DataHandler.setAdminCsvDuplicateData(duplicate_data);

      //           if (total_created > 0) {
      //             message.success("Customers has been uploaded successfully.");
      //           }

      //           // show modal
      //           setTimeout(
      //             () =>
      //               this.setState({
      //                 showDuplicateBFileConfirmationModal: true,
      //               }),
      //             50
      //           );
      //         } else {
      //           this.props.hideModal();
      //           message.success("Customers has been uploaded successfully.");
      //         }
      //       } else {
      //         message.error(resp.message);
      //         this.props.hideModal();
      //       }
      //     },
      //     error: () => {
      //       this.setState({ loading: false });
      //       message.error(F.translate(`Can't upload customers.`));
      //     },
      //   });

      // }

      // if (allFieldsColumnsCorrectlySelected) {
      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append("file", file);
      });
      formData.append("agency_id", this.state.agency_id);
      formData.append("user_id", this.state.user_id);
      formData.append("type_of_call", this.state.type_of_call);
      formData.append("sub_type_of_call", this.state.sub_type_of_call);

      formData.append("ordered_cols", JSON.stringify(this.state.ordered_cols));

      formData.append("notes", this.state.notes);
      this.setState({
        loading: true
      });

      reqwest({
        url: "/api/v1/admin_upload_bfile",
        method: "post",
        processData: false,
        data: formData,
        success: (resp) => {
          resp = JSON.parse(resp);

          // reset state
          this.setState({
            fileList: [],
            loading: false
          });

          // hide modal
          // this.props.hideModal();

          /**
           * Response: {"total_created": 0, "total_duplicate": 0, "duplicate_data": []}
           */

          const {
            success,
            total_created,
            total_duplicate,
            duplicate_data
          } = resp;

          // const a = Object.keys(duplicate_data).length > 0;
          // console.log("duplicate_data-->", a); // true

          /** Handle Server Message */

          if (success) {
            // show error if none of customer uploaded
            if (total_created === 0 && total_duplicate === 0) {
              message.error("Customers not uploaded");
              this.props.hideModal();
            } else if (duplicate_data.data.length > 0) {
              // set response `Duplicate data` in DataHandler class for using on next screen
              DataHandler.setAdminCsvDuplicateData(duplicate_data);

              if (total_created > 0) {
                message.success("Customers has been uploaded successfully.");
              }

              // show modal
              setTimeout(
                () =>
                  this.setState({
                    showDuplicateBFileConfirmationModal: true
                  }),
                50
              );
            } else {
              this.props.hideModal();
              message.success("Customers has been uploaded successfully.");
            }
          } else {
            message.error(resp.message, 10);
            this.props.hideModal();
          }
        },
        error: () => {
          this.setState({ loading: false });
          message.error(F.translate(`Can't upload customers.`));
        }
      });
      // }
    } else {
      const data = this.state.form;
      data.agency_id = this.state.agency_id;
      data.user_id = this.state.user_id;
      data.type_of_call = this.state.type_of_call;

      // if (
      //   !(
      //     (
      //       data.first_name &&
      //       data.last_name &&
      //       data.phone &&
      //       data.expiration_date
      //     ) //&&
      //     // data.rs_effective_date
      //   )
      // ) {
      //   form_error.expiration_date = !data.expiration_date
      //     ? "Active Call Date is required"
      //     : "";
      //   // form_error.rs_effective_date = !data.rs_effective_date
      //   //   ? "Effective date is required"
      //   //   : "";
      //   form_error.phone = !data.phone ? "Phone number is required" : "";
      //   form_error.last_name = !data.last_name ? "Last name is required" : "";
      //   form_error.first_name = !data.first_name
      //     ? "First name is required"
      //     : "";

      //   this.setState({ form_error });
      //   return;
      // }

      // reset Error States
      const newErrrData = {};
      newErrrData.first_name = "";
      newErrrData.last_name = "";
      newErrrData.email = "";
      newErrrData.phone = "";
      newErrrData.phone2 = "";
      newErrrData.expiration_date = "";
      newErrrData.rs_effective_date = "";

      this.setState(
        {
          form_error: newErrrData
        },
        () => {
          if (data.first_name === null || data.first_name.trim().length === 0) {
            newErrrData.first_name = "First Name is required.";
            this.setState({ form_error: newErrrData });
            return false;
          }
          if (data.last_name === null || data.last_name.trim().length === 0) {
            newErrrData.last_name = "Last Name is required.";
            this.setState({ form_error: newErrrData });
            return false;
          }

          if (
            data.email != null &&
            data.email.trim().length > 0 &&
            !F.validateEmail(data.email)
          ) {
            newErrrData.email = "Email is Invalid";
            this.setState({ form_error: newErrrData });
            return false;
          }

          if (data.phone === null || data.phone.trim().length === 0) {
            newErrrData.phone = "Phone Number is required";
            this.setState({ form_error: newErrrData });
            return false;
          }

          // validate regix
          if (!F.validatePhoneRegix(data.phone)) {
            newErrrData.phone = "Phone Number is Invalid";
            this.setState({ form_error: newErrrData });
            return;
          }

          if (
            data.phone2 != null &&
            data.phone2.trim().length > 0 &&
            !F.validatePhoneRegix(data.phone2.trim())
          ) {
            newErrrData.phone2 = "Alternate Phone Number is Invalid";
            this.setState({ form_error: newErrrData });
            return false;
          }

          if (!data.expiration_date) {
            newErrrData.expiration_date = "Active Call Date is required";
            this.setState({ form_error: newErrrData });
            return false;
          }

          this.checkDuplicateCustomer(data.phone);
        }
      );

      // this.setState({
      //   loading: true,
      // });

      // axios
      //   .post("/api/vob_add_customer", data)
      //   .then((res) => {
      //     const form = this.state.form;
      //     form.first_name = "";
      //     form.last_name = "";
      //     form.email = "";
      //     form.phone = "";
      //     form.address = "";
      //     form.address_cont = "";
      //     form.city = "";
      //     form.state = "";
      //     form.zipcode = "";
      //     form.expiration_date = null;
      //     form.rs_policy_type = "";
      //     form.rs_effective_date = null;
      //     form.notes = "";

      //     this.setState({
      //       fileList: [],
      //       loading: false,
      //       form,
      //     });

      //     message.success(
      //       F.translate(`Customers has been added successfully.`)
      //     );

      //     this.props.hideModal();
      //   })
      //   .catch((error) => {
      //     F.log(error);
      //     this.setState({
      //       loading: false,
      //     });
      //   });
    }
  };

  save = () => {
    const { fileList } = this.state;

    // reset notification
    message.destroy();

    if (this.validateFieldsSuccess()) {
      if (fileList.length === 0) {
        message.error(F.translate(`Please upload csv file.`));
        return;
      }
      // this.setState({ showUploadListConfirmationModal: true });

      // check All Columns Correctly Selected
      const allFieldsColumnsCorrectlySelected = F.checkAllColumnsCorrectlySelected(
        this.state.ordered_cols
      );

      if (allFieldsColumnsCorrectlySelected) {
        this.setState({ showUploadListConfirmationModal: true });
      }
    }
  };

  proceed = (csv) => {
    let data = csv.split("\n");
    let header = false;
    let newData = [];
    let delimiter = ",";
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== "") {
        if (!header) {
          header = true;
          let cols = data[i].split(delimiter);

          // get selected form fields
          const fieldsList =
            CSV_FORM_FIELDS[this.state.type_of_call][
            this.state.sub_type_of_call
            ];

          // get the required columns from the selected form fields
          // const default_template_columns = [];

          // old
          // const default_template_columns = fieldsList.map((item) => item.value);

          // new
          const default_template_columns = [];

          if (fieldsList) {
            for (let k = 0; k < fieldsList.length; k++) {
              if (fieldsList[k].required) {
                default_template_columns.push(fieldsList[k].value);
              }
            }
          }

          // for (let j = 0; j < fieldsList.length; j++) {
          //   const item = fieldsList[j];
          //   if (item.required) default_template_columns.push(item.value);
          // }

          const hasError = F.validateCsvColumns(cols, default_template_columns);

          if (hasError) {
            // close modal
            setTimeout(() => this.props.hideModal(), 100);
          } else {
            // check All Columns Exist In Csv Sheet Columns
            const ordered_cols = F.checkAllColumnsExistInCsvSheetColumns(cols);

            // continue if uploaded file has all required columns

            this.setState({
              cols,
              ordered_cols // new - add
              // old - below
              //  ordered_cols: {
              //    first_name: cols.length > 0 ? cols[0].trim() : null,
              //    last_name: cols.length > 1 ? cols[1].trim() : null,
              //    email: cols.length > 2 ? cols[2].trim() : null,
              //    address: cols.length > 3 ? cols[3].trim() : null,
              //    address_cont: cols.length > 4 ? cols[4].trim() : null,
              //    city: cols.length > 5 ? cols[5].trim() : null,
              //    state: cols.length > 6 ? cols[6].trim() : null,
              //    zipcode: cols.length > 7 ? cols[7].trim() : null,
              //    phone: cols.length > 8 ? cols[8].trim() : null,
              //    phone2: cols.length > 9 ? cols[9].trim() : null,
              //    expiration_date:
              //      cols.length > 10 ? cols[10].trim() : null,
              //    rs_policy_type:
              //      cols.length > 11 ? cols[11].trim() : null,
              //    rs_effective_date:
              //      cols.length > 12 ? cols[12].trim() : null,
              //    p_n_c_item_to_quote:
              //      cols.length > 13 ? cols[13].trim() : null,
              //    notes: cols.length > 14 ? cols[14].trim() : null,
              //  },
            });

            // ---------------------- NEW ------------------------

            // const ordered_cols = { ...this.state.ordered_cols };

            // // get csv all columns in lower case
            // const csv_columns_lowercase = cols.map(function(x) {
            //   return x
            //     .trim()
            //     .replace(/\W+/g, "")
            //     .toLowerCase();
            // });

            // // traverse through selected form fields and find column index to get It's value
            // for (let i = 0; i < fieldsList.length; i++) {
            //   const element = fieldsList[i];

            //   const index = csv_columns_lowercase.indexOf(
            //     element.value
            //       .trim()
            //       .replace(/\W+/g, "")
            //       .toLowerCase()
            //   );

            //   // unused fields remain same and update the selected form field required new flow
            //   ordered_cols[element.key] = index >= 0 ? cols[index] : null;
            // }
            // this.setState({
            //   cols,
            //   ordered_cols,
            // });
          }

          break;
        } else {
          newData.push(data[i].split(delimiter));
        }
      }
    }
  };
  fileUpdate = (file) => {
    const that = this;
    if (file.type === "text/csv") {
      const reader = new FileReader();
      reader.onload = function fileReadCompleted() {
        that.proceed(reader.result);
      };
      reader.readAsText(file);
    } else {
      // reset notification
      message.destroy();
      message.error(file.name + " is not a valid csv file. Please upload a .csv file.");
      this.setState({
        fileList: []
      });
    }
    return false;
  };
  updateCol = (name, val) => {
    let { ordered_cols } = this.state;
    ordered_cols[name] = val;
    this.setState({ ordered_cols });
  };

  renderFooter = () => {
    return (
      <div>
        <Button type="primary" onClick={() => this.save()}
          loading={this.state.loading}
          className="bg-164897 borderRadius-28">
          <Translate text={`Upload`} />
        </Button>
        <Button onClick={() => this.props.hideModal()}
          className="borderRadius-28"
        >
          <Translate text={`Cancel`} />
        </Button>
      </div>
    );
  };

  renderDownloadPathLink = () => {
    const path = F.isProductionHost()
      ? "/app/files/upload_customers_template.csv"
      : "/files/upload_customers_template.csv";

    // let { type_of_call, sub_type_of_call } = this.state;

    // // default set path until select the required options
    // let path = "javascript: void(0)";
    // let style = { color: "darkgrey", opacity: 0.5 };

    // if (type_of_call.length > 0 && sub_type_of_call.length > 0) {
    //   // get csv file name from the selected `Call Type` & `Call Sub Type`
    //   // const csv_file_name =
    //   //   TEMPLATE[this.state.type_of_call][this.state.sub_type_of_call];
    //   // path = F.isProductionHost()
    //   //   ? `/app/files/${csv_file_name}`
    //   //   : `/files/${csv_file_name}`;
    //   path = F.isProductionHost()
    //     ? "/app/files/upload_customers_template.csv"
    //     : "/files/upload_customers_template.csv";

    //   style = { opacity: 1 };
    // }

    return (
      <p>
        {/* <a href={path} style={style}> */}
        <a
          onClick={() => this.handleDownload(path)}
          onKeyPress={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              this.handleDownload(path);
            }
          }}
          role="button"
          tabIndex="0"
        >
          <Translate text="Step 1. Click here to download the formatted template." />
        </a>

        {/* <a  onClick={()=>this.handleDownload(path)}>
          <Translate
            text={`Step 1. Click here to download the formatted template.`}
          />
        </a> */}
      </p>
    );
  };


  handleDownload = (path) => {
    fetch(path)
      .then(response => response.blob())
      .then(blob => {
        // Extract the filename from the path
        const filename = path.substring(path.lastIndexOf('/') + 1);
        // Create a temporary URL pointing to the blob
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename; // Set the filename to the extracted filename
        document.body.appendChild(a);
        a.click();
        // Remove the temporary URL
        window.URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Error downloading CSV:', error));
  };


  renderStepTwoLabel = () => {
    return (
      <p>
        <Translate
          text={`Step 2. Select the staff member you would like to assign these customers to.`}
        />
      </p>
    );
  };

  // onSelectAgency = (val) => {
  //   // handle crash for empty value "select" from the drop down
  //   if (typeof val === "string" && val === "") {
  //     this.setState(
  //       {
  //         agency_id: null,
  //         users: [],
  //         user_id: null,
  //         fileList: [],
  //         cols: [],
  //         type_of_call: "",
  //         sub_type_of_call: "",
  //       },
  //       () => this.removeUploadedFileFromUI()
  //     );
  //   } else {
  //     const item = this.props.adminAgenciesList[val];
  //     this.setState(
  //       {
  //         select: val,
  //         agency_id: item.id,
  //         // user_id: item.primary_ea_id,
  //       },
  //       () => this.loadUsers()
  //     );
  //   }
  // };

  onSelectAgency = (val) => {
    // handle crash for empty value "select" from the drop down
    if (typeof val === "string" && val === "") {
      this.setState(
        {
          agency_id: null,
          users: [],
          user_id: null,
          fileList: [],
          cols: [],
          type_of_call: "",
          sub_type_of_call: ""
        },
        () => this.removeUploadedFileFromUI()
      );
    } else {
      let item = this.props.adminAgenciesList.find((agency) => agency.id == val);
      // let item = this.props.adminAgenciesList.find((user) => user.name === val);
      if (item && Object.keys(item).length > 0) {
        this.setState(
          {
            select: val,
            agency_id: item.id,
            users: [],
            user_id: null,
            fileList: [],
            cols: [],
            type_of_call: "",
            sub_type_of_call: ""
          },
          () => this.loadUsers()
        );
      }
    }
  };

  renderAgencyDropDown = () => {
    // const dataSource = this.props.adminAgenciesList.map((user) => user.name);

    return (
      <div style={{ marginBottom: 10 }}>
        <label>
          <Translate text={`Agency`} />
        </label>
        <AutoComplete
          style={{ width: "100%" }}
          placeholder="Select"
          allowClear
          optionLabelProp="children"
          filterOption={(inputValue, option) =>
            option.props.children
              .toLowerCase()
              .includes(inputValue.toLowerCase())
          }
          onSelect={(value) => this.onSelectAgency(value)}
        >
          {this.props.adminAgenciesList.map((agency) => (
            <Option key={agency.id} value={String(agency.id)}>
              {agency.name}
            </Option>
          ))}
        </AutoComplete>
        {/* <AutoComplete
          style={{ width: "100%" }}
          dataSource={dataSource}
          placeholder="Select"
          onSelect={this.onSelectAgency}
          onSearch={this.onSelectAgency}
          allowClear
          filterOption={(inputValue, option) =>
            option.props.children
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
        /> */}
      </div>
    );
  };

  onSelectAgencyStaff = (val) => {
    if (typeof val === "string" && val === "") {
      this.setState(
        {
          user_id: null,
          fileList: [],
          cols: [],
          type_of_call: "",
          sub_type_of_call: ""
        },
        () => this.removeUploadedFileFromUI()
      );
    } else {
      this.setState({ user_id: val });
    }
  };

  renderAgencyStaffDropDown = () => {
    const { users } = this.state;
    return users.length > 0 ? (
      <div style={{ marginBottom: 10 }}>
        <label>
          <Translate text={`Agency Staff`} />
        </label>
        <Select
          defaultValue={""}
          style={{ width: "100%" }}
          onChange={this.onSelectAgencyStaff}
        >
          <Option value={""}>
            <Translate text={`Select`} />
            ...
          </Option>
          {users.map((user, i) =>
            user.hidden === false ? (
              <Option key={i} value={user.id}>
                {user.name}
              </Option>
            ) : (
              ""
            )
          )}
        </Select>
      </div>
    ) : null;
  };

  renderTypeOfCall = () => {
    let { user_id } = this.state;
    if (user_id) {
      return (
        <div style={{ marginBottom: 10 }}>
          <label>
            <Translate text={`Type of Call`} />
          </label>
          <Select
            defaultValue={""}
            style={{ width: "100%" }}
            val={this.state.type_of_call}
            onChange={(value) => {
              this.setState({ type_of_call: "" }, () => {
                this.setState(
                  {
                    type_of_call: value,
                    fileList: [],
                    cols: [],
                    sub_type_of_call: ""
                  },
                  () => this.removeUploadedFileFromUI()
                );
              });
            }}
          >
            <Option value={""}>
              <Translate text={`Select`} />
              ...
            </Option>
            <Option value={"Review"}>
              <Translate text={`Review`} />
            </Option>
            <Option value={"Prospect"}>
              <Translate text={`Lead`} />
            </Option>
            <Option value={"FollowUp"}>
              <Translate text={`Opportunity`} />
            </Option>
          </Select>
        </div>
      );
    }
    return null;
  };

  renderSubTypesOfCall = () => {
    let { type_of_call, sub_type_of_call, user_id } = this.state;

    if (type_of_call.length > 0 && user_id) {
      const subType_list = SUB_TYPE_OF_CALL[type_of_call];

      return (
        <div style={{ marginBottom: 10 }}>
          <label>
            <Translate text={`Sub Type Of Call`} />
          </label>

          {/* {type_of_call && type_of_call.split("-").join("").toLowerCase() === 'followup' && <Checkbox.Group  value={sub_type_of_call&&sub_type_of_call.split(",")||[]} 
               onChange={(value)=>this.setState({sub_type_of_call:value.join()||""})} 
               style={{display:'flex',flexWrap:'wrap'}} 
               options={subType_list}   
             />}
            {type_of_call && ['prospect','review'].includes(type_of_call.toLowerCase()) &&
                    <Radio.Group style={{width:'100%'}} value={sub_type_of_call} name='sub_type_of_call' onChange={(e)=>this.setState({sub_type_of_call:e.target.value})}  >
                    <Row gutter={12}>
                      {subType_list.map((e,i)=>{
                        return(
                          <Col md={9} span={24}>
                          <Radio value={e}>{e}</Radio>
                          </Col>
                        )
                      })}
                    </Row>
                  </Radio.Group> 
               } */}

          <Select
            defaultValue={""}
            style={{ width: "100%" }}
            val={this.state.sub_type_of_call}
            onChange={(value) => {
              this.setState(
                {
                  fileList: [],
                  cols: [],
                  sub_type_of_call: value
                },
                () => this.removeUploadedFileFromUI()
              );
            }}
          >
            <Option value="">
              <Translate text={`Select`} />
              ...
            </Option>
            {subType_list.map((subType, i) => (
              <Option key={i} value={subType.value}>
                {subType.label}
              </Option>
            ))}
          </Select>
        </div>
      );
    }
    return null;
  };



  // renderCsvFormFields = () => {
  //   if (
  //     this.state.fileList.length > 0 &&
  //     this.state.cols.length > 0 &&
  //     this.state.type_of_call.length > 0 &&
  //     this.state.sub_type_of_call.length > 0
  //   ) {
  //     // get csv fields from the selected `Call Type` & `Call Sub Type`
  //     const fieldsList =
  //       CSV_FORM_FIELDS[this.state.type_of_call][this.state.sub_type_of_call];

  //     return fieldsList ? (
  //       <div style={{ marginTop: 30 }}>
  //         {fieldsList.map((fieldData) => {
  //           const val = this.state.ordered_cols[fieldData.key];

  //           return (
  //             // eslint-disable-next-line react/jsx-key
  //             <React.Fragment>
  //               <p>{fieldData.value}</p>
  //               <div style={{ marginBottom: 10 }}>
  //                 <Select
  //                   value={val}
  //                   style={{ width: "100%", textAlign: "center" }}
  //                   onChange={(val) => this.updateCol(fieldData.key, val)}
  //                   disabled={F.compareStrings(fieldData.value, val)}
  //                 >
  //                   <Option value={null}>Select column...</Option>
  //                   {this.state.cols.map((col, i) => (
  //                     <Option
  //                       key={i}
  //                       value={col.replace(/"/g, "").replace(/'/g, "")}
  //                     >
  //                       {col.replace(/"/g, "").replace(/'/g, "")}
  //                     </Option>
  //                   ))}
  //                 </Select>
  //               </div>
  //             </React.Fragment>
  //           );
  //         })}
  //       </div>
  //     ) : null;
  //   }
  //   return null;
  // };

  renderCsvFormFields = () => {
    if (
      this.state.fileList.length > 0 &&
      this.state.cols.length > 0 &&
      this.state.type_of_call.length > 0 &&
      this.state.sub_type_of_call.length > 0
    ) {
      return (
        <div style={{ marginTop: 30 }}>
          {// this.renderNestedFields()
            CSV_COLUMNS.map((fieldData) => {
              const val = this.state.ordered_cols[fieldData.key];
              return (
                // eslint-disable-next-line react/jsx-key
                <React.Fragment>
                  <p>{fieldData.value}</p>
                  <div style={{ marginBottom: 10 }}>
                    <Select
                      value={val}
                      style={{ width: "100%", textAlign: "center" }}
                      onChange={(val) => this.updateCol(fieldData.key, val)}
                      disabled={F.compareStrings(fieldData.value, val)}
                    >
                      <Option value={null}>Select column...</Option>
                      {this.state.cols.map((col, i) => (
                        <Option
                          key={i}
                          value={col.replace(/"/g, "").replace(/'/g, "")}
                        >
                          {col.replace(/"/g, "").replace(/'/g, "")}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      );
    }
    return null;
  };
  removeUploadedFileFromUI = () => {
    const fileList = this.state.fileList;


    for (let i = 0; i < fileList.length; i++) {
      fileList.splice(i, 1);
    }
    this.setState((prevState) => {
      return {
        ...prevState,
        fileList: fileList
      }
    })
    // this.setState({ fileList });
  };

  renderCsvUploadFileContainerAndFormFields = () => {
    const sub_type_of_call = this.state.sub_type_of_call;

    const disabled = sub_type_of_call.trim().length <= 0;
    const props = {
      action: "/api/upload_bfile_vob",
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList
          };
        });
      },
      beforeUpload: (file) => {
        this.setState(({ fileList }) => ({
          fileList: [file]
        }));
        this.fileUpdate(file);
        return false;
      },
      fileList: this.state.fileList,
      disabled
      // onChange: (info) => {
      //   console.log("NOOR --> ", info);
      // },
    };

    return this.state.action === "upload_file" ? (
      <div>
        <label>
          <Translate text={`File`} />
        </label>
        <Upload {...props}>
          <Button onClick={this.validateFieldsSuccess}
            className="borderRadius-28"
          >
            <Icon type="upload" /> <Translate text={`Upload`} />
          </Button>
        </Upload>

        {this.renderCsvFormFields()}
      </div>
    ) : null;
  };

  renderManualUploadFormFields = () => {
    const { form, form_error } = this.state;

    return this.state.action === "add_manually" ? (
      <div>
        <Row gutter={16}>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                {/* <Translate text={`First Name`} /> * */}
                <Translate text={`First Name`} /> <span className="required-symbol">*</span>
              </label>
              <Input
                value={form.first_name}
                onChange={(e) => this.updateField("first_name", e.target.value)}
                maxLength={50}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {form_error.first_name}
              </p>
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                {/* <Translate text={`Last Name`} /> * */}
                <Translate text={`Last Name`} /> <span className="required-symbol">*</span>
              </label>
              <Input
                value={form.last_name}
                onChange={(e) => this.updateField("last_name", e.target.value)}
                maxLength={50}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {form_error.last_name}
              </p>
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={24} span={24}>
            <div className="inputField">
              <label>
                {/* <Translate text={`Email`} /> */}
                <Translate text={`Email`} /> <span className="required-symbol">*</span>
              </label>
              <Input
                value={form.email}
                onChange={(e) => this.updateField("email", e.target.value)}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {form_error.email}
              </p>
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                {/* <Translate text={`Phone`} /> * */}
                <Translate text={`Phone`} /> <span className="required-symbol">*</span>
              </label>
              <Input
                value={F.phone_format(form.phone)}
                // type="text"
                // maxLength={11}
                // onChange={(e) =>
                //   this.updateField("phone", e.target.value)
                // }
                onChange={(e) => {
                  if (e.target.value.trim().length <= 14) {
                    const updateNumber = F.phone_format(e.target.value);
                    // F.log("noor 3 " + updateNumber);
                    this.updateField("phone", updateNumber);
                  }
                }}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {form_error.phone}
              </p>
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Alternate Phone`} />
              </label>
              <Input
                value={F.phone_format(form.phone2)}
                type="text"
                maxLength={11}
                onChange={(e) => this.updateField("phone2", e.target.value)}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {form_error.phone2}
              </p>
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Mailing Street1`} />
              </label>
              <Input
                value={form.address}
                onChange={(e) => this.updateField("address", e.target.value)}
              />
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Mailing Street2`} />
              </label>
              <Input
                value={form.address_cont}
                onChange={(e) =>
                  this.updateField("address_cont", e.target.value)
                }
              />
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Mailing City`} />
              </label>
              <Input
                value={form.city}
                onChange={(e) => this.updateField("city", e.target.value)}
              />
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Mailing State`} />
              </label>
              <Input
                value={form.state}
                onChange={(e) => this.updateField("state", e.target.value)}
              />
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Mailing Zip`} />
              </label>
              <Input
                value={form.zipcode}
                onChange={(e) => this.updateField("zipcode", e.target.value)}
              />
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Policy Type`} />
              </label>
              <Input
                value={form.rs_policy_type}
                onChange={(e) =>
                  this.updateField("rs_policy_type", e.target.value)
                }
              />
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Schedule by Date`} /> *
              </label>
              <DatePicker
                value={form.expiration_date}
                format="MM/DD/YYYY"
                onChange={(val) => this.updateField("expiration_date", val)}
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  // Can not select days before today and today
                  return F.getFutureDateForAppointmentFromAntdDatePicker(
                    current
                  );
                }}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {form_error.expiration_date}
              </p>
            </div>
          </Col>
          <Col md={12} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Active Call Date`} />
              </label>
              <DatePicker
                value={form.rs_effective_date}
                format="MM/DD/YYYY"
                onChange={(val) => this.updateField("rs_effective_date", val)}
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  // Can not select days before today and today
                  return F.getFutureDateForAppointmentFromAntdDatePicker(
                    current
                  );
                }}
              />
              <p
                style={{
                  color: "red",
                  paddingTop: "4px",
                  paddingLeft: "6px"
                }}
              >
                {/* {form_error.rs_effective_date} */}
              </p>
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col md={24} span={24}>
            <div className="inputField">
              <label>
                <Translate text={`Notes`} />
              </label>
              <TextArea
                rows={4}
                value={form.notes}
                onChange={(e) => this.updateField("notes", e.target.value)}
              />
            </div>
          </Col>
        </Row>
      </div>
    ) : null;
  };

  onEditAllDuplicateBFiles = () => {
    this.setState({ showDuplicateBFileConfirmationModal: false }, () => {
      this.props.hideModal();

      let prev = window.location.pathname.split("/");
      let current = prev[prev.length - 1];

      if (current == "duplicate-files") {
        const callback = DataHandler.getDuplicateDataCallback();
        callback && callback();
      } else {
        setTimeout(() => {
          this.props.history.push({ pathname: "/super-admin/duplicate-files", state: { type_of_call: this.state.type_of_call } });
        }, 100);
      }
    });
  };

  onDiscardAllDuplicateBFiles = () => {
    this.setState({ showDuplicateBFileConfirmationModal: false }, () => {
      this.props.hideModal();
    });
  };

  onConfirmedUploadFile = () => {
    this.setState({ showUploadListConfirmationModal: false }, () => {
      this.uploadFile();
    });
  };

  onCancelUploadFile = () => {
    this.setState({ showUploadListConfirmationModal: false }, () => {
      // this.props.hideModal();
    });
  };

  render() {
    const { loading } = this.state;

    return (
      <Modal
        title={<Translate text={`Upload Customers`} />}
        visible={this.props.showModal}
        onCancel={this.props.hideModal}
        width={'600px'}
        footer={this.renderFooter()}
      >
        <Spin indicator={antIcon} spinning={loading}>
          <div className="formBox">
            {this.renderDownloadPathLink()}

            {this.renderStepTwoLabel()}

            {this.renderAgencyDropDown()}

            {this.renderAgencyStaffDropDown()}

            {/* <TypeOfCal type_of_call="Follow-Up" /> */}

            {this.renderTypeOfCall()}

            {this.renderSubTypesOfCall()}

            {this.renderCsvUploadFileContainerAndFormFields()}

            {this.renderManualUploadFormFields()}
          </div>
        </Spin>

        <CustomerExist
          showModal={this.state.showCustomerExistsModal}
          ok={(id) => {
            this.setState({ showCustomerExistsModal: false }, () => {
              setTimeout(() => {
                this.uploadCustomer();
              }, 100);
            });
          }}
          cancel={() => {
            this.setState({ showCustomerExistsModal: false }, () => {
              // this.props.history.push("/dashboard");
            });
          }}
        />

        <ConfirmationModal
          showModal={this.state.showDuplicateBFileConfirmationModal}
          title="Confirmation"
          okText="Edit"
          cancelText="Discard"
          message="There are some duplicate B Files in the system. Would you like to discard them all, or edit them?"
          ok={this.onEditAllDuplicateBFiles}
          cancel={this.onDiscardAllDuplicateBFiles}
        />

        <ConfirmationModal
          showModal={this.state.showUploadListConfirmationModal}
          title="Confirmation"
          okText="Yes"
          cancelText="No"
          message="Are you sure you want to upload this list?"
          ok={this.onConfirmedUploadFile}
          cancel={this.onCancelUploadFile}
        />
      </Modal>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/components/upload-customers-admin-modal.js